module.exports = __webpack_public_path__ + "static/img/image_solutions_optics_05.4186db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_optics_05.png
// module id = 3ZP7
// module chunks = 10